<template>
  <Button
    type="button"
    :class="calculateClassButton"
    @click="$emit('click')"
  >
    <slot />
  </Button>
</template>
<script>
import CONFIG from '../config';

export default {
    name: 'ToolbarButton',
    props: {
        selected: {
            type: Boolean,
            required: true,
        },
        suffix: {
            type: String,
            default: '',
        },
    },
    computed: {
        calculateClassButton() {
            const width = window.innerWidth;
            if (width < CONFIG.responsive.minWithInfoChart) {
                return `btn btn${this.selected ? '' : '-outline'}-primary button-foot-bar button-foot-bar-middle`;
            }
            return `btn btn${this.selected ? '' : '-outline'}-primary button-foot-bar ${this.suffix.length ? `button-foot-bar-${this.suffix}` : ''}`;
        },
    },
};
</script>
<style lang="scss">
@import "../scss/style";
.button-foot-bar {
  padding-left: 10px!important;
  padding-right: 10px!important;
  margin: 0px!important;
  border-radius: 0px!important;
  font-size: 12px!important;
}
.button-foot-bar-first {
  padding-left: 20px!important;
  border-top-left-radius:30px!important;
  border-bottom-left-radius:30px!important;
}
.button-foot-bar-last {
  padding-right: 20px!important;
  border-top-right-radius:30px!important;
  border-bottom-right-radius:30px!important;
}
.button-foot-bar-middle {
  padding-right: 20px!important;
  padding-left: 20px!important;
  border-top-right-radius:30px!important;
  border-top-left-radius:30px!important;
  border-bottom-right-radius:30px!important;
  border-bottom-left-radius:30px!important;
}
.button-foot-bar + .button-foot-bar{
  border-left: none;
}
</style>
